import http from './http'

const NO_AUTH_API = '/saas_api_noauth.php'

function postForm(action, data = {}) {
  const formData = new URLSearchParams()
  Object.keys(data).forEach(key => {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key, data[key])
    }
  })
  return http.post(`${NO_AUTH_API}?action=${action}`, formData, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

export function loginByOpenid(openid) {
  return postForm('login_by_openid', { openid })
}

export function generateLoginQrcode() {
  return postForm('generate_qrcode')
}

export function checkLoginQrcodeStatus(uuid) {
  return postForm('check_qrcode_status', { uuid })
}

export function bindInviter(inviterId) {
  return http.post('/saas_finance.php?action=bind_inviter', new URLSearchParams({
    inviter_id: String(inviterId)
  }), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
